//import { AppData } from './revisionData';
import { UserProfile } from 'src/app/core/models/user';
import type { Editor } from '@ckeditor/ckeditor5-core';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { GDPRService } from 'src/app/core/services/rulebook';
import { TrackChanges } from '@ckeditor/ckeditor5-track-changes';
import { CommentsRepository } from '@ckeditor/ckeditor5-comments';
import type { Users } from '@ckeditor/ckeditor5-collaboration-core';
import * as customBuild from './../../../../../ckCustomeBuild/build/ckeditor';
import type { RevisionData, RevisionHistory } from '@ckeditor/ckeditor5-revision-history';
import { AppDataWithoutRevision, ckUses } from 'src/app/core/models/ckEditor/revisionData';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppData, revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { SelfAssessmentCkDataSaveModel } from 'src/app/core/models/self-assessmentT2/update-self-assessmentT2-model';
import { UserService } from 'src/app/core/services/user';
import { NotepadService } from 'src/app/core/services/notepad/notepad.service';
import * as _ from 'underscore';
// import { from } from 'rxjs';
// import { promise } from 'protractor';
//import { CommentsAdapter, TrackChangesAdapter, RevisionHistoryAdapter, UsersInitWithRevision } from '../ckEditor-adapter';
//import { UsersInit, RevisionHistoryAdapter, CommentsAdapter, TrackChangesAdapter } from '../ck-editor/revision-history-adapter';

@Component({
	selector: 'app-ck-editor-revision',
	templateUrl: './ck-editor-revision.component.html',
	styleUrls: ['./ck-editor-revision.component.scss']
})

export class CkEditorRevisionComponent implements OnInit, AfterViewInit {
  @Input() isSaveDisable: boolean = false;
	@Input() data: string = "";
	@Input() noteId: string = "";
	@Input() userInfo!: UserProfile;
	@Input() editorUsers: string = "";
	@Input() selfAssessmentId: number = 0;
	@Input() accessType: revisionHistoryAccessTypeEnum = revisionHistoryAccessTypeEnum.All;
	@Output() keyUpEvent = new EventEmitter<void>();
	@Output() childVariableChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() saveEditorDate: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('myEditor') myEditor: any;

	public editorData = "";
	public editor!: Editor;
	public licenseKey: string = "";
	public readonly: boolean = false;
	public buttonActive: boolean = false;

	editorContainer: string = 'editor-container';
	revisionViewerEditor: string = '';
	revisionViewerContainer: string = '';
	revisionViewerSidebar: string = '';
	commentVal = false;
	updatedValue: string = '';
	showEditor: boolean = true;
	editorUsersArray: string[] = [];
	notepadService: NotepadService;
	revisionData: string = "";
	isEditorLoad: boolean = false;
	trackData: string = "";

	public toolbarItem = [
		'undo',
		'redo',
		'|',
		'revisionHistory',
		'trackChanges',
		'comment',
		'commentsArchive',
		'|',
		'bold',
		'italic',
		'underline',
		'strikethrough',
		'link',
		'bulletedList',
		'numberedList',
		'todoList',
		'subscript',
		'superscript',
		'horizontalLine',
		'|',
		'alignment',
		'outdent',
		'indent',
		'specialCharacters',
		'|',
		'insertTable',
		'imageUpload',
		'imageInsert',
		'blockQuote',
		'selectAll',
		'findAndReplace',
		'|',
		'fontSize',
		'fontFamily',
		'fontColor',
		'fontBackgroundColor',
		'highlight',
		'removeFormat',
		'|',
		// 'htmlEmbed',
		// 'showBlocks',
		// '|',
		'heading',
		// 'style',
		'textPartLanguage'
	];
	accessManageFunction() {
		if (this.accessType === revisionHistoryAccessTypeEnum.Readonly) {
			this.readonly = true;
			this.toolbarItem = [];
		}
		else if (this.accessType === revisionHistoryAccessTypeEnum.CommentOnly) {
			// comment only
			this.readonly = false;
			this.commentVal = true;
			this.toolbarItem = ['comment', 'commentsArchive'];
		}
		else if (this.accessType === revisionHistoryAccessTypeEnum.All) {
			// this.showEditor = true;
		}
		else {
		}
	}

	public Editor = customBuild.Editor;
	@ViewChild('sidebar', { static: true }) private sidebarContainer?: ElementRef<HTMLDivElement>;
	private sidebar = document.createElement('div');

	public get editorConfig() {
		return {
			commentsOnly: this.commentVal,
			removePlugins: ['Title'],
			extraPlugins: [this.UsersInitWithRevision(this.userInfo, this.editorUsersArray),
			this.RevisionHistoryAdapter(this.noteId, this.notepadService, this.revisionData),
			this.CommentsAdapter(this.userInfo, this.noteId, this.notepadService, this.commentsData),
			this.TrackChangesAdapter(this.noteId, this.userInfo, this.notepadService, this.trackData, this.commentsData)],
			sidebar: {
				container: this.sidebar,
			},
			licenseKey: 'TzM4ZXFzODFYUnh6YUl5dEYzQ0ZxMVlBTWQrUGVHOWFQZXQvKzM2SloxQndRZ29vRGtxbE0rdkw5dmIwR25KWUFZST0tTWpBeU5EQTVNVFE9',

			revisionHistory: {
				editorContainer: document.querySelector('#' + this.editorContainer)!,
				viewerContainer: document.querySelector('#' + this.revisionViewerContainer)!,
				viewerEditorElement: document.querySelector('#' + this.revisionViewerEditor)!,
				viewerSidebarContainer: document.querySelector('#' + this.revisionViewerSidebar)!,
				resumeUnsavedRevision: true
			},

			toolbar: {
				items: this.toolbarItem
			},
			style: {
				definitions: []
			}

		};
	}

	public ngAfterViewInit(): void {
		this.isEditorLoad = true;
		if (!this.sidebarContainer) {
			throw new Error('Div container for sidebar was not found');
		}
		this.sidebarContainer.nativeElement.appendChild(this.sidebar);
	}

	public onChange({ editor }: ChangeEvent) {
		if (editor?.data.get()) {
			this.notepadService.editorDataUpdate({ key: this.noteId, value: true });
			//this.buttonActive = true;
		}
	}
	constructor(private _userService: UserManagementService, private gdprService: GDPRService,
		notepad: NotepadService, private ref: ChangeDetectorRef, private el: ElementRef) {
		this.notepadService = notepad;
	}
	public ngOnInit(): void {
		this.editorContainer = this.editorContainer + '-' + this.noteId;
		this.revisionViewerEditor = 'revision-viewer-editor' + '-' + this.noteId;
		this.revisionViewerContainer = 'revision-viewer-container' + '-' + this.noteId;
		this.revisionViewerSidebar = 'revision-viewer-sidebar' + '-' + this.noteId;

		this.editorUsersArray = this.editorUsers ? this.editorUsers.split(',') : [];
		if (!this.editorUsersArray.includes(this.userInfo?.fullName)) {
			this.editorUsersArray.push(this.userInfo?.fullName);
		}
		const myObject = JSON.parse(this.data);
		this.appData.noteId = this.noteId;
		this.editorData = myObject?.data;

		if (myObject?.revisionHistory) {
			//localStorage.setItem("revisionHistoryData-" + this.appData.noteId, myObject?.revisionHistory);
			this.revisionData = myObject.revisionHistory;
			this.notepadService.ckeditorRevisionDataUpdate({ key: this.noteId, value: myObject.revisionHistory });
		}
		else {
			this.revisionData = '';
		}

		if (myObject?.userComment) {
			//localStorage.setItem('userComment-' + this.appData.noteId, myObject?.userComment);
			this.commentsData = myObject.userComment;
			this.notepadService.ckeditorCommentDataUpdate({ key: this.noteId, value: myObject.userComment });
		}
		else {
			this.commentsData = '';
		}

		if (myObject?.trackChages) {
			//localStorage.setItem("trackChanges-" + this.appData.noteId, myObject?.trackChages);
			this.trackData = myObject.trackChages;
			this.notepadService.ckeditorTrackDataUpdate({ key: this.noteId, value: myObject.trackChages });
		}
		else {
			this.trackData = '';
		}

		this.accessManageFunction();
		this._userService
			.GetCkEditorKey()
			.subscribe((result) => {
				this.licenseKey = result?.result;
			});
		this.notepadService._editorDataChange$.subscribe((isDataChange) => {
			if (isDataChange.key == this.noteId && isDataChange.value) {
				this.buttonActive = true;
				this.ref.detectChanges();
				this.updatedValue = this.myEditor.editorInstance?.getData({ ignoreResolvedComments: true }); 	// get updated data from editor

				let ckData = {
					data: this.updatedValue,
					userComment: this.commentsData,
					trackChages: this.trackData,
					revisionHistory: this.revisionData
				}
				this.childVariableChange.emit(JSON.stringify(ckData));
			}
		});
		this.notepadService._ckeditorRevisionData$.subscribe((rivisionData) => {
			if (rivisionData.key == this.noteId) {
				this.revisionData = rivisionData.value;
			}
		});
		this.notepadService._ckeditorTrackData$.subscribe((trackData) => {
			if (trackData.key == this.noteId) {
				this.trackData = trackData.value;
			}
		});
		this.notepadService._ckeditorCommentData$.subscribe((commentData) => {
			if (commentData.key == this.noteId) {
				this.commentsData = commentData.value;
			}
		});
	}


	appData: AppData = new AppData();
	commentsData: any;
	isFocused: boolean = false;
	trackchangesOn() {}
	public async CalledUpdatedSelfAssessmentData():Promise<void>{
    	await this.UpdateData();
	}

	public async revisionHistorySave(): Promise<void> {
		return new Promise(async (resolve, reject) => {
			try {
				const revisionTracker = this.myEditor.editorInstance.plugins.get('RevisionHistoryAdapter');
				const revisionTrackerPlugin = revisionTracker.editor.plugins.get('RevisionTracker');
				this.updatedValue = this.myEditor.editorInstance.getData({ ignoreResolvedComments: true }); // get updated data from editor
				await revisionTrackerPlugin.saveRevision();
				resolve(); // Resolve the promise when saveRevision completes successfully
			} catch (error) {
				reject(error); // Reject the promise if an error occurs
			}
		});
	}
	public async UpdateData() {
		this.buttonActive = false; // disable save button
		await this.revisionHistorySave();

		// create object with all data
		let ckData = {
			data: this.updatedValue,
			userComment: this.commentsData,
			trackChages: this.trackData,
			revisionHistory: this.revisionData
		};
		this.childVariableChange.emit(JSON.stringify(ckData));  			// emit data to parent component
		const data = new SelfAssessmentCkDataSaveModel();		// create object for save data
		data.ckData = JSON.stringify(ckData); 					// set data to object
		data.ckName = this.noteId;								// set note id to object
		data.selfAssessmentT2Id = this.selfAssessmentId; 					// set self assessment id to object
		data.userName = this.userInfo.fullName; 					// set user name to object

    this.saveEditorDate.emit(data);
	}

	UsersInitWithRevision(user: UserProfile, editorUsers: string[]) {
		return class UsersInitWithRevision {

			public editor: Editor;
			public constructor(editor: Editor) {
				this.editor = editor;
			}

			static get pluginName() {
				return 'UsersInit';
			}

			static get requires() {
				return ['Users'];
			}

			init() {
				const users = this.editor.plugins.get('Users') as Users;
				for (let i = 0; i < editorUsers.length; i++) {
					if (editorUsers[i]) {
						let ob = new ckUses();
						ob.id = editorUsers[i];
						ob.name = editorUsers[i];
						users.addUser(ob);
					}
				}
				users.defineMe(user.fullName);
			}
		}

	}

	CommentsAdapter(userInfo: UserProfile, appId: string, _notepadService: NotepadService, commentDataArray: any) {
		return class CommentsAdapter {
			//public userService: UserService;
			public editor: Editor;
			public constructor(editor: Editor) {
				this.editor = editor;
			}
			static get requires() {
				return ['CommentsRepository'];
			}
			async init() {
				const commentsRepositoryPlugin = this.editor.plugins.get('CommentsRepository') as CommentsRepository;
				_notepadService._ckeditorCommentData$.subscribe((commentData) => {
					if (commentData.key == appId) {
						commentDataArray = commentData.value;
					}
				});
				commentsRepositoryPlugin.adapter = {
					async addComment(data: any) {
						// let commentsString: any = localStorage.getItem('userComment-' + appId);
						// let addReply = JSON.parse(commentsString)

						// Write a request to your database here. The returned `Promise`
						// should be resolved when the request has finished.
						// When the promise resolves with the comment data object, it
						// will update the editor comment using the provided data.

						const commentDataArray_ = commentDataArray ? commentDataArray : [];

						// localStorage.setItem('commentDataArray_' + appId, JSON.stringify(commentDataArray_));

						const matchComment = commentDataArray_?.find((item: { mainComment: { threadId: any; }; }) => item.mainComment.threadId === data.threadId);

						data.authorId = userInfo.fullName;
						data.createdAt = new Date();

						if (matchComment?.mainComment.comments) {
							matchComment.mainComment.comments.push(data);
						} else {
							let newData = {
								mainComment: {
									attributes: {},
									comments: [data],
									threadId: data.threadId
								},
								replies: []
							}
							commentDataArray_.push(newData)
						}

						await _notepadService.editorDataUpdate({ key: appId, value: true });
						await _notepadService.ckeditorCommentDataUpdate({ key: appId, value: commentDataArray_ });

						return Promise.resolve({
							commentId: data.commentId,
							createdAt: new Date(), // Should be set on the server side.
						});
					},
					async updateComment(data) {
						// Retrieve existing data from localStorage
						// const existingMainDataString = localStorage.getItem('userComment-' + appId);
						// // Parse existing data into an array or initialize an empty array if no data exists
						// let existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
						const existingMainData = commentDataArray ? commentDataArray : [];
						existingMainData.forEach((item: any) => {
							if (item.mainComment.threadId == data.threadId) {
								item.mainComment.comments.forEach((element: any) => {
									if (element.commentId == data.commentId) {
										element.content = data.content;
									}
								});

							}
						})
						//localStorage.setItem("userComment-" + appId, JSON.stringify(existingMainData));
						await _notepadService.ckeditorCommentDataUpdate({ key: appId, value: existingMainData });
						await _notepadService.editorDataUpdate({ key: appId, value: true });
						return Promise.resolve();
					},
					async removeComment(data) {
						// const existingMainDataString = localStorage.getItem('userComment-' + appId);
						// let existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
						const existingMainData = commentDataArray ? commentDataArray : [];
						existingMainData.forEach((item: any) => {
							if (item.mainComment.threadId == data.threadId) {
								item.mainComment.comments = item.mainComment.comments.filter((item: any) => item.commentId !== data.commentId);
							}
						})
						await _notepadService.ckeditorCommentDataUpdate({ key: appId, value: existingMainData });
						await _notepadService.editorDataUpdate({ key: appId, value: true });
						//localStorage.setItem("userComment-" + appId, JSON.stringify(existingMainData));
						return Promise.resolve();
					},

					addCommentThread(data: any) {
						// Sample data structure
						const newCommentThread = {
							mainComment: data,
							replies: [],
						};

						const existingMainData = commentDataArray ? commentDataArray : [];
						existingMainData.push(newCommentThread);
						_notepadService.ckeditorCommentDataUpdate({ key: appId, value: existingMainData });
						return Promise.resolve({
							threadId: data.threadId,
							comments: data.comments?.map((comment: { commentId: any }) => ({
								commentId: comment.commentId,
								createdAt: new Date(),
							})), // Should be set on the server side.
						});
					},
					getCommentThread(data) {
						//let commentsString = localStorage.getItem('userComment-' + appId);
						let comments: any = commentDataArray ? commentDataArray : [];

						if (comments !== null) {

							//comments = JSON.parse(commentsString);

							// const thread = comments.find(thread => thread.threadId === data.threadId);
							const thread = comments?.find((thread: { mainComment: { threadId: string; }; }) => thread.mainComment.threadId === data.threadId);

							const threadComment = thread.mainComment.comments?.map((comment: { commentId: any; authorId: any; content: any; createdAt: any; attributes: any; }) => ({
								commentId: comment.commentId,
								authorId: comment.authorId,
								content: comment.content,
								createdAt: comment.createdAt,
								attributes: comment.attributes,
							}))


							if (thread) {
								// Return the dynamic comment data
								return Promise.resolve({
									threadId: thread.mainComment.threadId,
									comments: threadComment,
									context: {
										type: 'text',
										value: '',
									},
									unlinkedAt: null,
									resolvedAt: thread.mainComment.resolvedAt,
									resolvedBy: thread.mainComment.resolvedBy,
									attributes: {},
									isFromAdapter: true,
								});
							}
						}

						// Write a request to your database here. The returned `Promise`
						// should resolve with the comment thread data.
						return Promise.resolve({
							threadId: data.threadId,
							comments: [
								{
									commentId: '',
									authorId: userInfo.fullName,
									content: '<p>comments?</p>',
									createdAt: new Date(),
									attributes: {},
								},
							],
							// It defines the value on which the comment has been created initially.
							// If it is empty it will be set based on the comment marker.
							context: {
								type: 'text',
								value: '',
							},
							unlinkedAt: null,
							resolvedAt: null,
							resolvedBy: null,
							attributes: {},
							isFromAdapter: true,
						});
					},
					updateCommentThread(data) {

						// Write a request to your database here. The returned `Promise`
						// should be resolved when the request has finished.
						return Promise.resolve();
					},
					resolveCommentThread: async (data) => {
						// Iterate through each item in the parsedExistingMainData
						const existingMainData = commentDataArray ? commentDataArray : [];
						existingMainData.forEach((item: any) => {
							if (item.mainComment.threadId === data.threadId) {
								// Update resolvedAt and resolvedBy properties
								item.mainComment.resolvedAt = new Date();
								item.mainComment.resolvedBy = userInfo.fullName;
							}
						});
						await _notepadService.ckeditorCommentDataUpdate({ key: appId, value: existingMainData });
						await _notepadService.editorDataUpdate({ key: appId, value: true });

						//localStorage.setItem("userComment-" + appId, JSON.stringify(existingMainData));
						// localStorage.setItem('editorData-'+ appData.noteId, this.editor?.data.get());

						// Write a request to your database here. The returned `Promise`
						// should be resolved when the request has finished.
						return Promise.resolve({
							threadId: data.threadId,
							resolvedAt: new Date(), // Should be set on the server side.
							resolvedBy: userInfo.fullName, // Should be set on the server side.
						});
					},

					async reopenCommentThread(data) {
						// Retrieve existing data from localStorage
						// const existingMainDataString = localStorage.getItem('userComment-' + appId);
						// // Parse existing data into an array or initialize an empty array if no data exists
						// const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
						const existingMainData = commentDataArray ? commentDataArray : [];
						// Check if the thread exists in the existing data
						const existingThread = existingMainData.find((item: any) => item.mainComment.threadId === data.threadId);
						if (existingThread) {
							// Update the resolvedAt and resolvedBy properties
							existingThread.mainComment.resolvedAt = null;
							existingThread.mainComment.resolvedBy = null;
						}

						// Remove data.threadId thread from the existing data existingMainData
						let newUpdatedCommentArr = existingMainData.filter((item: any) => item.mainComment.threadId !== data.threadId);

						// existingThread to newUpdatedCommentArr
						newUpdatedCommentArr.push(existingThread);
						await _notepadService.ckeditorCommentDataUpdate({ key: appId, value: newUpdatedCommentArr });
						await _notepadService.editorDataUpdate({ key: appId, value: true });

						// Write a request to your database here. The returned `Promise`
						// should be resolved when the request has finished.
						return Promise.resolve();
					},

					removeCommentThread(data) {

						// const existingMainDataString = localStorage.getItem('userComment-' + appId);
						// // Parse existing data into an array or initialize an empty array if no data exists
						// const existingMainData = existingMainDataString ? JSON.parse(existingMainDataString) : [];
						const existingMainData = commentDataArray ? commentDataArray : [];
						const newUpdatedCommentArr = existingMainData.filter((item: any) => item.mainComment.threadId !== data.threadId);
						_notepadService.ckeditorCommentDataUpdate({ key: appId, value: newUpdatedCommentArr });
						//localStorage.setItem("userComment-" + appId, JSON.stringify(newUpdatedCommentArr));
						return Promise.resolve();
					}
				};
			}


		}
	}
	//export class TrackChangesAdapter {
	TrackChangesAdapter(appId: string, userInfo: UserProfile, _notepadService: NotepadService, trackDataArray: any, commentDataArray: any) {
		return class TrackChangesAdapter {
			public editor: Editor;
			public constructor(editor: Editor) {
				this.editor = editor;
			}
			async init() {
				//appData.noteId = appId;
				const trackChangesPlugin = this.editor.plugins.get(
					'TrackChanges'
				) as TrackChanges;
				_notepadService._ckeditorTrackData$.subscribe((trackData) => {
					if (trackData.key == appId) {
						trackDataArray = trackData.value;
					}
				});
				trackChangesPlugin.adapter = {

					getSuggestion: (suggestionId: string): Promise<any> => {
						// const trackChangesArray = trackDataArray ? this.convertToArray(trackDataArray) : [];
						const trackChangesArray = trackDataArray ? trackDataArray : [];
						let matchedSuggestion = trackChangesArray?.find((suggestion: { id: string; }) => suggestion.id === suggestionId);

						let trackChangeDate = new Date();
						if (matchedSuggestion.createdAt){
							trackChangeDate = matchedSuggestion.createdAt
						}

						// _notepadService.ckeditorTrackDataUpdate({ key: appId, value: matchedSuggestion });

						// Write a request to your database here.
						// The returned `Promise` should be resolved with the suggestion
						// data object when the request has finished.
						return Promise.resolve({
							id: matchedSuggestion.id,
							type: matchedSuggestion.type,
							authorId: matchedSuggestion.authorId,
							hasComments: matchedSuggestion.hasComments,
							createdAt: trackChangeDate,
							data: null,
							attributes: {}
						});
					},

					addSuggestion: async (suggestionData): Promise<any> => {
						const trackChangesData = suggestionData;

						let trackChanges_obj = {
							id: trackChangesData.id,
							type: trackChangesData.type,
							authorId: userInfo.fullName,
							hasComments: trackChangesData.hasComments,
							data: trackChangesData.data,
							originalSuggestionId: trackChangesData.originalSuggestionId,
							attributes: trackChangesData.attributes,
							createdAt: new Date(),
						}

						const trackDataArray_ = trackDataArray ? trackDataArray : [];
						trackDataArray_.push(trackChanges_obj);

						// Store the JSON string in local storage with a key (e.g., "UserComment")
						await _notepadService.ckeditorTrackDataUpdate({ key: appId, value: trackDataArray_ });
						await _notepadService.editorDataUpdate({ key: appId, value: true });

						//localStorage.setItem("trackChanges-" + appId, JSON.stringify(existingMainData));
						// Write a request to your database here.
						// The returned `Promise` should be resolved when the request
						// has finished. When the promise resolves with the suggestion data
						// object, it will update the editor suggestion using the provided data.
						return Promise.resolve({
							createdAt: new Date(), // Should be set on the server side.
						});
					},

					updateSuggestion: async (id, suggestionData) => {
						let trackDataArray_ = trackDataArray ? trackDataArray : [];
						const matchedUpdateSuggestionIndex = trackDataArray_.findIndex((suggestion: { id: string; }) => suggestion.id === id);
						if (matchedUpdateSuggestionIndex !== -1) {
							if (suggestionData.hasComments) {
								trackDataArray_[matchedUpdateSuggestionIndex].hasComments = suggestionData.hasComments;
							}
							if (suggestionData.state) {
								// Remove associated comments to the suggestion
								if (trackDataArray_[matchedUpdateSuggestionIndex].hasComments == true) {
									let commentsArray = commentDataArray ? commentDataArray : [];
									commentsArray = commentsArray?.filter((obj: { mainComment: { threadId: any; }; }) => obj.mainComment.threadId !== id);
									_notepadService.ckeditorCommentDataUpdate({ key: appId, value: commentsArray });
								}
								// Remove the suggestion from the array
								trackDataArray_ = trackDataArray_?.filter((obj: { id: string; }) => obj.id !== id);
							}
							await _notepadService.ckeditorTrackDataUpdate({ key: appId, value: trackDataArray_ });
							await _notepadService.editorDataUpdate({ key: appId, value: true });
						}
						// Write a request to your database here.
						// The returned `Promise` should be resolved when the request
						// has finished.
						return Promise.resolve();
					},
				};
			}
			convertToArray(data: any): any[] {
				if (Array.isArray(data)) {
					// If it's already an array, return it as is
					return data;
				} else {
					// If it's not an array, convert it to an array and return
					return [data];
				}
			}
		}
	}

	RevisionHistoryAdapter(appId: string, _notepadService: NotepadService, revisionDataArray: any) {
		return class RevisionHistoryAdapter {
			public editor: Editor;
			public constructor(editor: Editor) {
				this.editor = editor;
			}
			static get pluginName() {
				return 'RevisionHistoryAdapter';
			}

			static get requires() {
				return ['RevisionHistory'];
			}

			async init() {
				const revisionHistory = this.editor.plugins.get('RevisionHistory') as RevisionHistory;
				_notepadService._ckeditorRevisionData$.subscribe((revisionData) => {
					if (revisionData.key == appId) {
						revisionDataArray = revisionData.value;
					}
				});
				revisionHistory.adapter = {
					getRevision: ({ revisionId }): Promise<any> => {
						const revisionArray = revisionDataArray ? revisionDataArray : [];
						const matchedRevisionId = revisionArray?.find((item: { id: string; }) => item.id === revisionId);
						return Promise.resolve(matchedRevisionId);
					},

					updateRevisions: async (
						revisionsData: Array<RevisionData>
					): Promise<Array<RevisionData>> => {

						// This should be an asynchronous request to your database
						// that saves `revisionsData` and `documentData`.
						// Document data should be saved each time a revision is saved.

						const existingRevisionData = revisionDataArray ? revisionDataArray : [];
						let revisionsToAdd = revisionsData.filter((obj: { hasOwnProperty: (arg0: string) => any; }) => obj.hasOwnProperty('name'));
						revisionsToAdd = revisionsToAdd.filter(item => item.creatorId !== null); // remove null creatorId
						if (revisionsToAdd && existingRevisionData.length > 0) {
							// revisionsToAdd = revisionsToAdd.filter(item => item.authorsIds && item.authorsIds.length > 0 || item.id === "initial");
							revisionsToAdd = revisionsToAdd.filter(item => item.authorsIds && item.authorsIds.length > 0);
							// revisionsToAdd = revisionsToAdd.filter(item => item.authorsIds);
						};

						// Concatenate the existing and new revisions
						const updatedRevisionData = existingRevisionData.concat(revisionsToAdd);
						if (revisionsToAdd.length > 0) {
								// Sort the updatedRevisionData array by createdAt in ascending order
								updatedRevisionData.sort((a:{createdAt:Date;}, b:{createdAt:Date;}) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

								// Get the last revision's toVersion
								let maxVersion = 0;
								if (updatedRevisionData.length > 0) {
								maxVersion = updatedRevisionData[updatedRevisionData.length - 1].toVersion;
								}

								// Assign fromVersion and toVersion for the revisions
								updatedRevisionData.forEach((revision: any, index: number) => {
								revision.toVersion = maxVersion + index + 1;

								if (index === 0) {
									// For the first revision in the sorted list
									revision.fromVersion = 0;
								} else {
								// For subsequent revisions, set fromVersion to the previous revision's toVersion
								revision.fromVersion = updatedRevisionData[index - 1].toVersion;
							}

							// Handle the initial revision case
							if (revision.id === "initial") {
								revision.fromVersion = 0;
								revision.toVersion = 1;
							}
							});
						}
						await _notepadService.ckeditorRevisionDataUpdate({ key: appId, value: updatedRevisionData });
						return Promise.resolve() as Promise<any>;
					},
				};

				// Add the revisions data for existing revisions.
				// You can either dump the revisions data straight in the source code, or
				// you can fetch the data asynchronously from your database (as this example shows).
				//
				// Note that the revisions data does not contain `diffData` property.
				// `diffData` property may be big and will be fetched on demand by `adapter.getRevision()`.
				//

				const revisionsData = await this._fetchRevisionsData();
				// if (revisionsData) {
				// 	for (const revisionData of revisionsData) {
				// 		revisionHistory.addRevisionData(revisionData as any);
				// 	}
				// }				
				for (const revisionData of revisionsData) {
					revisionHistory.addRevisionData(revisionData as any);
				}
			}

			async _fetchRevisionsData() {

				const revisionArray = revisionDataArray ? revisionDataArray : [];
				// Make an asynchronous call to your database.
				const mappedRevisions = revisionArray?.map((revisionObj: { id: any; name: any; creatorId: any; authorsIds: any; createdAt: any; fromVersion: any; toVersion: any; }) => ({
					id: revisionObj.id,
					name: revisionObj.name,
					creatorId: revisionObj.creatorId,
					authorsIds: revisionObj.authorsIds,
					createdAt: revisionObj.createdAt,
					attributes: {},
					fromVersion: revisionObj.fromVersion,
					toVersion: revisionObj.toVersion,
				}));
				if (mappedRevisions) {
					return Promise.resolve(mappedRevisions);
				} else {
					return Promise.resolve([]);
				}
			}
		}
	}
}
